import { render, staticRenderFns } from "./jhi-navbar-extended.vue?vue&type=template&id=4287f842&"
import script from "./jhi-navbar-extended.component.ts?vue&type=script&lang=ts&"
export * from "./jhi-navbar-extended.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports